import { Dropdown } from 'antd/lib/index'
import styled from 'styled-components'

export const StyledDropdown = styled(Dropdown)``
